import { GridDirection, GridProps, GridSpacing } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { Text } from 'components/text';
import React, { FC } from 'react';

import { TitleWithValue } from '../title-with-value';

type TitleWithValueProps = {
  title: string,
  value: string | number,
  titleVariant?: Variant,
  valueVariant?: Variant,
  direction?: GridDirection,
  justifyContent?: GridProps['justifyContent'],
  spacing?: GridSpacing,
  titleUppercase?: boolean,
  valueIsMoney?: boolean,
  valueLeftAdorment?: string | React.ReactNode,
  isLoading?: boolean,
  loadingRowsNumber?: number
  decimals?: number,
  titleClassName?: string
}

export const TitleWithTextValue: FC<TitleWithValueProps> = ({
  title,
  value,
  titleVariant = 'caption',
  valueVariant = 'body2',
  direction = 'column',
  justifyContent = 'flex-start',
  spacing = 0,
  titleUppercase = true,
  valueIsMoney = false,
  valueLeftAdorment = null,
  isLoading = false,
  loadingRowsNumber = 1,
  decimals = 2,
  titleClassName
}) => (
  (
    <TitleWithValue
      title={title}
      titleVariant={titleVariant}
      direction={direction}
      justifyContent={justifyContent}
      spacing={spacing}
      titleUppercase={titleUppercase}
      isLoading={isLoading}
      loadingRowsNumber={loadingRowsNumber}
      titleClassName={titleClassName}
    >
      <Text
        value={value}
        variant={valueVariant}
        isMoney={valueIsMoney}
        decimals={decimals}
        leftAdorment={valueLeftAdorment}
        fontWeight="bold"
        color="textPrimary"
      />
    </TitleWithValue>
  )
);
